module.exports = __webpack_public_path__ + "img/nipige.e03918a4.svg";